import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useStyles from './styles'
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Divider,
  Box,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { closeDialog } from 'actions/dialogs'
import { isEmpty } from 'lodash'
import classnames from 'clsx'
import ItemType from 'components/ItemsList/Item/ItemType'
import Scrollbars from 'react-scrollbars-custom'
import AutoSizer from 'react-virtualized-auto-sizer'
import Action from './Action'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const ItemDialog = () => {
  const classes = useStyles()

  const dialog = useSelector(state => state.dialogs.item)

  const open = dialog !== undefined ? dialog.open : false
  const data = dialog !== undefined ? dialog.data : {}

  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(closeDialog('item'))
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{
        paper: classes.dialogPaper
      }}
      TransitionComponent={Transition}
      keepMounted
    >
      {!isEmpty(data) && (
        <Fragment>
          <IconButton onClick={handleClose} className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
          <DialogContent
            className={classnames(classes.dialogContent, classes.image)}
          >
            <img
              className={classes.bigImage}
              src={data.image[0].square_full_url}
            />
          </DialogContent>
          <DialogContent
            className={classnames(classes.dialogContent, classes.content)}
          >
            <AutoSizer>
              {({ height, width }) => (
                <Scrollbars
                  style={{
                    height: height - 1,
                    width
                  }}
                  permanentTracks={false}
                  // removeTracksWhenNotUsed
                >
                  <ItemType className={classes.itemType} item={data} />
                  <Typography
                    className={classes.itemTitleTypography}
                    color="secondary"
                    variant="h2"
                  >
                    {data.name}
                  </Typography>
                  <Typography className={classes.itemIDTypography}>
                    Item ID: {data.item_code}
                  </Typography>
                  <Typography
                    className={classes.itemDescriptionTypography}
                    dangerouslySetInnerHTML={{
                      __html: data.formattedDescription
                    }}
                  />
                  <Divider className={classes.divider} />
                  {data.value_display !== 2 ? (
                    <Typography
                      variant="h3"
                      color="primary"
                      className={classes.retailValue}
                    >
                      Retail Value:{' '}
                      {data.value_display === 0
                        ? '$' + data.value
                        : 'Priceless'}
                    </Typography>
                  ) : null}
                  <Box display="flex" justifyContent="center">
                    <Action item={data} />
                  </Box>
                </Scrollbars>
              )}
            </AutoSizer>
          </DialogContent>
        </Fragment>
      )}
    </Dialog>
  )
}

export default ItemDialog



// WEBPACK FOOTER //
// ./src/dialogs/Item/index.jsx